// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Kontent$PrezzeeRibbon from "../Kontent/Kontent.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Animation$PrezzeeRibbon from "../../../theme/Theme__Animation.bs.js";
import * as Theme__Typography$PrezzeeRibbon from "../../../theme/Theme__Typography.bs.js";

var card = BsCssJs$PrezzeeRibbon.merge([
      Theme__Typography$PrezzeeRibbon.Styles.body,
      BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.position("relative")])
    ]);

var photo = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.position("relative"),
      BsCssJs$PrezzeeRibbon.zIndex(1),
      BsCssJs$PrezzeeRibbon.selector("img", [
            BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.height("auto"),
            BsCssJs$PrezzeeRibbon.display("block")
          ])
    ]);

var text = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.flexDirection("column"),
      BsCssJs$PrezzeeRibbon.justifyContent("center"),
      BsCssJs$PrezzeeRibbon.textAlign("center"),
      BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.rem(1.25)),
      BsCssJs$PrezzeeRibbon.backgroundColor(BsCssJs$PrezzeeRibbon.rgba(227, 11, 23, {
                NAME: "num",
                VAL: 0.75
              })),
      BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.white),
      BsCssJs$PrezzeeRibbon.opacity(0),
      BsCssJs$PrezzeeRibbon.transitionProperty("opacity"),
      BsCssJs$PrezzeeRibbon.transitionDuration(Theme__Animation$PrezzeeRibbon.regular),
      BsCssJs$PrezzeeRibbon.transitionTimingFunction(BsCssJs$PrezzeeRibbon.cubicBezier(0.4, 0, 0.2, 1)),
      BsCssJs$PrezzeeRibbon.transitionDelay(0),
      BsCssJs$PrezzeeRibbon.position("absolute"),
      BsCssJs$PrezzeeRibbon.zIndex(2),
      BsCssJs$PrezzeeRibbon.left("zero"),
      BsCssJs$PrezzeeRibbon.top("zero"),
      BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100)),
      BsCssJs$PrezzeeRibbon.boxSizing("borderBox"),
      BsCssJs$PrezzeeRibbon.children([BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100))]),
      BsCssJs$PrezzeeRibbon.selector("&:hover", [BsCssJs$PrezzeeRibbon.opacity(1)])
    ]);

var name = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.textTransform("uppercase"),
      BsCssJs$PrezzeeRibbon.fontWeight("bold"),
      BsCssJs$PrezzeeRibbon.margin3("zero", "zero", BsCssJs$PrezzeeRibbon.rem(1.25))
    ]);

var title = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.margin("zero")]);

var Styles = {
  card: card,
  photo: photo,
  text: text,
  name: name,
  title: title
};

function BoardOfDirectorsCard(props) {
  return JsxRuntime.jsx(Kontent$PrezzeeRibbon.Consumer.make, {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("p", {
                                    children: props.name,
                                    className: name
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: props.title,
                                    className: title
                                  })
                            ],
                            className: text
                          }),
                      JsxRuntime.jsx("div", {
                            children: props.photo,
                            className: photo
                          })
                    ],
                    className: card
                  })
            });
}

var make = BoardOfDirectorsCard;

export {
  Styles ,
  make ,
}
/* card Not a pure module */
